import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowGraphCommands } from '../constant';
import { MODELS } from '../../model-service';
export var NsGraphMeta;
(function (NsGraphMeta) {
    /** Command Id: 用于注册named factory */
    NsGraphMeta.command = XFlowGraphCommands.LOAD_META;
    /** hookName */
    NsGraphMeta.hookKey = 'graphMeta';
})(NsGraphMeta || (NsGraphMeta = {}));
let GraphMetaCommand = class GraphMetaCommand {
    constructor() {
        /** 执行Cmd */
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.graphMeta.call(
            /** 执行hooks pipeline处理args */
            args, 
            /** 执行 callback */
            (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const { graphMetaService } = handlerArgs;
                const meta = graphMetaService
                    ? yield graphMetaService(handlerArgs)
                    : Object.assign({}, handlerArgs === null || handlerArgs === void 0 ? void 0 : handlerArgs.meta);
                return Object.assign({ flowId: meta === null || meta === void 0 ? void 0 : meta.flowId }, meta);
            }), 
            /** 外部的 hook */
            runtimeHook);
            const modelService = this.ctx.getModelService();
            /** 如果已经注册，直接更新已有的值 */
            const model = yield MODELS.GRAPH_META.getModel(modelService);
            model.setValue(result);
            /** 设置结果 */
            this.ctx.setResult(result);
            return this;
        });
        /** undo cmd */
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        /** redo cmd */
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    /** isUndoable */
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], GraphMetaCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GraphMetaCommand.prototype, "init", null);
GraphMetaCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsGraphMeta.command.id },
    })
    /** 创建节点命令 */
], GraphMetaCommand);
export { GraphMetaCommand };
//# sourceMappingURL=graph-meta.js.map